module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/pageIndex/dragTable-02bc56.svg";